import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sss-landing-hero',
  templateUrl: './landing-hero.component.html',
  styleUrls: ['./landing-hero.component.scss']
})
export class LandingHeroComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
